import _defineProperty from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _ from 'lodash';
import xml2js from 'xml2js';
import { Country, ErrorType, RE_EMAIL, State as StateEnum } from '@tradingblock/types';
import { BeneficiaryAccountType } from '@tradingblock/types';
export var RE_VALID_FIRST_NAME = /^(\s*)[a-zA-Z-]+(\s*)$/;
export var RE_VALID_TRUSTED_CONTACT_LAST_NAME = /^(\s*)[a-zA-Z-]+(\s*)$/;
export var RE_VALID_LAST_NAME = /^(\s*)[a-zA-Z-]+( [a-zA-Z-]+)?(\s*)$/;
export var RE_VALID_FIRST_NAME_WITH_NUMBERS = /^(\s*)[a-zA-Z0-9-]+(\s*)$/;
export var RE_VALID_TRUSTED_CONTACT_LAST_NAME_WITH_NUMBERS = /^(\s*)[a-zA-Z0-9-]+(\s*)$/; // PO Box addresses not allowed for home address

export var RE_PO_BOX = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i; // Check if address input is in the correct ASCII Range

export var RE_POSTAL_CODE = /^\d{5}(-\d{4})?$/; // Check if address input is in the correct ASCII Range

export var ASCII_AUDIT_RANGE = /^[\u0020-\u007E]+$/;

var getError = function getError(value, error) {
  if (!value && !_.isNumber(value)) {
    return error;
  }

  return undefined;
};

var getRequiredError = function getRequiredError(value) {
  return getError(value, ErrorType.Required);
};

var getInvalidError = function getInvalidError(value) {
  return getError(value, ErrorType.Invalid);
};

var getMismatchError = function getMismatchError(value) {
  return getError(value, ErrorType.Mismatch);
};

var getEmailError = function getEmailError(value) {
  return getRequiredError(value) || getInvalidError(value && RE_EMAIL.test(value));
};

var getInvalidLengthError = function getInvalidLengthError(value) {
  return getError(value, ErrorType.InvalidLength);
}; // Promise parser for parsing xml to json


var promisesParser = function promisesParser(string) {
  return new Promise(function (resolve, reject) {
    xml2js.parseString(string, function (err, result) {
      if (err) {
        return reject(err);
      } else {
        return resolve(result);
      }
    });
  });
}; // USPS Address Verification


var uspsVerification =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(address, uspsBaseUrl, uspsId) {
    var requestConfig, address1, address2, city, state, postalCode, country, xml, simplifyAddress, isFlipped, response, xmlText, xmlResult, AddressValidateResponse, Address, _Address$, City, State, Zip5, Zip4, Address1, Address2, _Error, _Error$, _Number, Source, Description, address1Value, address2Value, _ref2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestConfig = {
              Headers: {
                'Content-Type': 'text/xml',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Credentials': true,
                'Access-Control-Allow-Methods': 'GET'
              },
              method: 'get'
            };
            address1 = address.address1, address2 = address.address2, city = address.city, state = address.state, postalCode = address.postalCode, country = address.country; // Build XML Request

            xml = "<AddressValidateRequest USERID=\"".concat(uspsId, "\"><Address ID=\"0\"><Address1>").concat(encodeURIComponent(address1), "</Address1><Address2>").concat(encodeURIComponent(address2), "</Address2><City>").concat(city, "</City><State>").concat(state, "</State><Zip5>").concat(postalCode, "</Zip5><Zip4></Zip4></Address></AddressValidateRequest>"); // Utility function to simplify address for comparison
            // Removes common suffixes, unit indicators, directional abbreviations, and whitespace

            simplifyAddress = function simplifyAddress(address) {
              return address.toUpperCase().replace(/\b(STREET|ST\.?|ROAD|RD\.?|AVENUE|AVE\.?|BOULEVARD|BLVD\.?|DRIVE|DR\.?|LANE|LN\.?|COURT|CT\.?|CIRCLE|CIR\.?|TERRACE|TER\.?|PLACE|PL\.?|LOOP|LOOP|HIGHWAY|HWY\.?|PARKWAY|PKWY\.?|ALLEY|ALY\.?|PLAZA|PLZ\.?|PATH|PATH|WAY|WAY)\b/gi, '' // Remove common street suffixes
              ).replace(/\b(UNIT|APT|APARTMENT|SUITE|STE|#)\b/gi, '') // Normalize unit indicators
              .replace(/\b(SOUTH|S\.?|NORTH|N\.?|EAST|E\.?|WEST|W\.?)\b/gi, '') // Normalize directional abbreviations
              .replace(/\s+/g, ' ') // Replace multiple whitespace with a single space
              .trim();
            }; // Function to check if addresses are flipped in USPS validation response based on simplified comparison


            isFlipped = function isFlipped(address1, address2) {
              return _.includes(simplifyAddress(address1), simplifyAddress(address2));
            }; // If address has been provided, excluding postal code, and country is US, then perform USPS verification


            _context.prev = 5;

            if (!(address1 && city && state && country === Country.UnitedStatesOfAmerica && state !== StateEnum.PuertoRico)) {
              _context.next = 28;
              break;
            }

            _context.next = 9;
            return fetch("".concat(uspsBaseUrl).concat(xml), requestConfig);

          case 9:
            response = _context.sent;
            _context.next = 12;
            return response.text();

          case 12:
            xmlText = _context.sent;
            _context.next = 15;
            return promisesParser(xmlText);

          case 15:
            xmlResult = _context.sent;
            AddressValidateResponse = xmlResult.AddressValidateResponse;
            Address = AddressValidateResponse.Address;
            _Address$ = Address[0], City = _Address$.City, State = _Address$.State, Zip5 = _Address$.Zip5, Zip4 = _Address$.Zip4, Address1 = _Address$.Address1, Address2 = _Address$.Address2, _Error = _Address$.Error;

            if (!_Error) {
              _context.next = 24;
              break;
            }

            // Handle API error response
            _Error$ = _Error[0], _Number = _Error$.Number, Source = _Error$.Source, Description = _Error$.Description;
            return _context.abrupt("return", {
              error: {
                number: _Number[0],
                source: Source[0],
                description: Description[0]
              }
            });

          case 24:
            // Extract address lines from API response
            address1Value = Address1 ? Address1[0] : null;
            address2Value = Address2 ? Address2[0] : null; // Correct the address lines if they have been flipped

            if (!address1Value) {
              address1Value = address2Value;
              address2Value = null;
            } else if (Address1 && isFlipped(address1, address2Value)) {
              // Swap the address lines using array destructuring
              _ref2 = [address2Value, address1Value];
              address1Value = _ref2[0];
              address2Value = _ref2[1];
            } // Return the corrected and standardized address components


            return _context.abrupt("return", {
              city: City[0] || '',
              state: State[0] || '',
              zip5: Zip5[0] || '',
              zip4: Zip4[0] || '',
              uspsAddress1: address1Value || '',
              uspsAddress2: address2Value || null
            });

          case 28:
            _context.next = 33;
            break;

          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](5);
            console.error(_context.t0);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 30]]);
  }));

  return function uspsVerification(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}(); // Function to get USPS response from storage


var getUspsResponseFromStorage = function getUspsResponseFromStorage(prefix) {
  var uspsResponseFromStorage = sessionStorage.getItem("".concat(prefix.split('.')[0], "UspsResponse"));
  return uspsResponseFromStorage && uspsResponseFromStorage !== 'undefined' ? uspsResponseFromStorage : null;
}; // Async function to handle USPS verification


var getUSPS =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(address, uspsBaseUrl, uspsId) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });

          case 2:
            _context2.next = 4;
            return uspsVerification(address, uspsBaseUrl, uspsId);

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUSPS(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}(); // Function to validate the address using the USPS response


var validateWithUspsResponse = function validateWithUspsResponse(uspsResponse, address, prefix, uspsBaseUrl, userId) {
  var isValidAddress = false;
  var uspsResponseValue; // Destructuring address object to get individual address components

  var address1 = address.address1,
      address2 = address.address2,
      city = address.city,
      state = address.state,
      country = address.country;

  if (state === StateEnum.PuertoRico) {
    return {};
  } // Check if a USPS response exists and is not 'undefined'


  if (uspsResponse && uspsResponse !== 'undefined') {
    // Parse the USPS response
    uspsResponseValue = JSON.parse(uspsResponse); // Extract relevant data from the parsed USPS response

    var _uspsResponseValue = uspsResponseValue,
        _city = _uspsResponseValue.city,
        _state = _uspsResponseValue.state,
        zip5 = _uspsResponseValue.zip5,
        error = _uspsResponseValue.error,
        uspsAddress1 = _uspsResponseValue.uspsAddress1,
        uspsAddress2 = _uspsResponseValue.uspsAddress2; // Format the city name for comparison

    var formattedCityCapitalized = _.capitalize(_city);

    var startCaseCity = _.startCase(formattedCityCapitalized); // Compare each component of the address with the USPS response


    var isCityEqual = _.toLower(startCaseCity) === _.toLower(address.city);

    var isZipEqual = zip5 === address.postalCode;
    var isStateEqual = _state === address.state;
    var isAddressEqual = uspsAddress2 ? uspsAddress1 === address.address1.toUpperCase() && uspsAddress2 === address.address2.toUpperCase() : uspsAddress1 === address.address1.toUpperCase();
    var isAddressCorrect = !error && isCityEqual && isZipEqual && isStateEqual && isAddressEqual; // Set the flag based on the address comparison results

    isValidAddress = isAddressCorrect;
  } // Clear USPS storage if address fields are cleared


  if (!address1 || !city) {
    sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), 'undefined');
  } // If address has been provided, excluding postal code, country is US but the current address is not valid, then perform USPS verification to retrieve valid address items or errors


  if (address1 && city && state && country === Country.UnitedStatesOfAmerica && !isValidAddress || address1 && address2 && city && state && country === Country.UnitedStatesOfAmerica && !isValidAddress) {
    // Set USPS Verification result to sessionStorage
    getUSPS(address, uspsBaseUrl, userId).then(function (result) {
      sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), JSON.stringify(result));
      uspsResponseValue = result;
    });
  }

  if (uspsResponseValue && address.country === Country.UnitedStatesOfAmerica) {
    var _uspsResponseValue2 = uspsResponseValue,
        _city2 = _uspsResponseValue2.city,
        _state2 = _uspsResponseValue2.state,
        _zip = _uspsResponseValue2.zip5,
        _error = _uspsResponseValue2.error,
        _uspsAddress = _uspsResponseValue2.uspsAddress1,
        _uspsAddress2 = _uspsResponseValue2.uspsAddress2;

    if (_error && address.address1 && address.city && address.state && address.postalCode) {
      var _ref4;

      return _ref4 = {}, _defineProperty(_ref4, "".concat(prefix, "postalCode"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref4, "".concat(prefix, "city"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref4, "".concat(prefix, "state"), "".concat(_error.description.trim(), " Please review the entered address.")), _defineProperty(_ref4, "".concat(prefix, "address1"), "".concat(_error.description.trim(), " Please review the entered address.")), _ref4;
    }

    if (!address.address1 || !address.city) {
      sessionStorage.setItem("".concat(prefix.split('.')[0], "UspsResponse"), 'undefined');
    }

    if (_city2 && _state2 && _zip) {
      // Formatting for error message display of USPS response
      var _formattedCityCapitalized = _.capitalize(_city2);

      var _startCaseCity = _.startCase(_formattedCityCapitalized);

      var _isCityEqual = _.toLower(_startCaseCity) === _.toLower(address.city);

      var _isZipEqual = _zip === address.postalCode;

      var _isStateEqual = _state2 === address.state;

      var isAddress1Equal = _uspsAddress === address.address1.toUpperCase();

      var isAddress2Equal = _uspsAddress2 === address.address2.toUpperCase();

      var formattedAddress1 = _uspsAddress.toLowerCase().split(' ').map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
      }).join(' ');

      var formattedAddress2 = _uspsAddress2 ? _uspsAddress2.toLowerCase().split(' ').map(function (s) {
        return s.charAt(0).toUpperCase() + s.substring(1);
      }).join(' ') : null; // Required Errors

      if (!address.postalCode) {
        return _defineProperty({}, "".concat(prefix, "postalCode"), getRequiredError(address.postalCode));
      }

      if (!address.city) {
        return _defineProperty({}, "".concat(prefix, "city"), getRequiredError(address.city));
      } // USPS Verification Errors


      var errors = {};

      if (!_isCityEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "city"), "Please verify city. USPS Provided City: ".concat(_startCaseCity)));
      }

      if (!_isZipEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "postalCode"), "Please verify the zip code. USPS Provided Zip Code: ".concat(_zip)));
      }

      if (!_isStateEqual) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "state"), "Please verify the state. USPS Provided State: ".concat(_state2)));
      }

      if (!isAddress1Equal) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address1"), "Please utilize the USPS provided formatting: ".concat(formattedAddress1)));
      }

      if (_uspsAddress2 && !isAddress2Equal) {
        errors = Object.assign({}, errors, _defineProperty({}, "".concat(prefix, "address2"), "Please utilize the USPS provided formatting: ".concat(formattedAddress2)));
      }

      return errors;
    }
  }
};

export var validateAddress = function validateAddress(address, uspsBaseUrl, uspsId, field) {
  var prefix = "".concat(field || 'address', ".");

  var isMailing = _.toLower(prefix).includes('mailing');

  var stateOrPostalCodeRequired = address.country === Country.UnitedStatesOfAmerica;
  var isTrustedContactAddress = field.toLowerCase().includes('trustedcontact');
  var uspsResponseFromStorage = getUspsResponseFromStorage(prefix.split('.')[0]);
  var uspsValidationErrors = validateWithUspsResponse(uspsResponseFromStorage, address, prefix, uspsBaseUrl, uspsId);

  if (Object.keys(uspsValidationErrors || {}).length > 0) {
    return uspsValidationErrors || {};
  }

  if (!isMailing) {
    var _errors;

    var errors = (_errors = {}, _defineProperty(_errors, "".concat(prefix, "country"), getRequiredError(address.country)), _defineProperty(_errors, "".concat(prefix, "address1"), getRequiredError(address.address1) || !isTrustedContactAddress && getInvalidError(!RE_PO_BOX.test(address.address1)) || getInvalidError(ASCII_AUDIT_RANGE.test(address.address1)) || getInvalidLengthError(address.address1.length <= 30) || address.address1 && getInvalidError(_.trim(address.address1) !== '')), _defineProperty(_errors, "".concat(prefix, "postalCode"), getRequiredError(stateOrPostalCodeRequired ? address.postalCode : true) || getInvalidError(stateOrPostalCodeRequired ? RE_POSTAL_CODE.test(address.postalCode) : true)), _defineProperty(_errors, "".concat(prefix, "city"), getRequiredError(address.city)), _defineProperty(_errors, "".concat(prefix, "state"), getRequiredError(stateOrPostalCodeRequired ? address.state : true)), _errors); // Only validate address2 if it has a value

    if (address.address2 && address.address2.trim() !== '') {
      errors["".concat(prefix, "address2")] = !isTrustedContactAddress && getInvalidError(!RE_PO_BOX.test(address.address2)) || getInvalidError(ASCII_AUDIT_RANGE.test(address.address2)) || getInvalidLengthError(address.address2.length <= 30) || getInvalidError(_.trim(address.address2) !== '');
    } // Remove any undefined errors


    Object.keys(errors).forEach(function (key) {
      return errors[key] === undefined && delete errors[key];
    });
    return errors;
  } else if (isMailing) {
    var _errors3;

    var _errors2 = (_errors3 = {}, _defineProperty(_errors3, "".concat(prefix, "country"), getRequiredError(address.country)), _defineProperty(_errors3, "".concat(prefix, "address1"), getRequiredError(address.address1) || address.address1 && getInvalidError(_.trim(address.address1) !== '')), _defineProperty(_errors3, "".concat(prefix, "postalCode"), getRequiredError(stateOrPostalCodeRequired ? address.postalCode : true)), _defineProperty(_errors3, "".concat(prefix, "city"), getRequiredError(address.city)), _defineProperty(_errors3, "".concat(prefix, "state"), getRequiredError(stateOrPostalCodeRequired ? address.state : true)), _errors3); // Only validate address2 if it has a value


    if (address.address2 && address.address2.trim() !== '') {
      _errors2["".concat(prefix, "address2")] = getInvalidError(_.trim(address.address2) !== '');
    } // Remove any undefined errors


    Object.keys(_errors2).forEach(function (key) {
      return _errors2[key] === undefined && delete _errors2[key];
    });
    return _errors2;
  }
};

var validatePhoneNumber = function validatePhoneNumber(value) {
  // Correct the regex pattern to allow multiple digits, underscores, and hyphens
  var regex = /^[0-9_-]+$/; // Check if the value matches the regex and if its length (not including "-") is greater than 10

  return regex.test(value) && value.replace(/-/g, '').length >= 10;
};

export var validateTrustedContactFields = function validateTrustedContactFields(values, uspsBaseUrl, uspsId) {
  var isDevelopmentEnv = process.env.REACT_APP_ENVIRONMENT === 'dev';
  return Object.assign({
    'trustedContact.firstName': getRequiredError(values.trustedContact.firstName) || getInvalidError(isDevelopmentEnv ? RE_VALID_FIRST_NAME_WITH_NUMBERS.test(values.trustedContact.firstName) : RE_VALID_FIRST_NAME.test(values.trustedContact.firstName)) || getInvalidLengthError(values.trustedContact.firstName.length <= 20),
    'trustedContact.lastName': getRequiredError(values.trustedContact.lastName) || getInvalidError(isDevelopmentEnv ? RE_VALID_TRUSTED_CONTACT_LAST_NAME_WITH_NUMBERS.test(values.trustedContact.lastName) : RE_VALID_TRUSTED_CONTACT_LAST_NAME.test(values.trustedContact.lastName)) || getInvalidLengthError(values.trustedContact.lastName.length <= 20)
  }, validateAddress(values.trustedContact.address, uspsBaseUrl, uspsId, 'trustedContact.address'), {
    'trustedContact.email': getEmailError(values.trustedContact.email),
    'trustedContact.phones[0].phoneNumber': getRequiredError(values.trustedContact.phones[0].phoneNumber) || getInvalidError(validatePhoneNumber(values.trustedContact.phones[0].phoneNumber))
  });
};
export var validateBeneficiaryPercentages = function validateBeneficiaryPercentages(beneficiaries) {
  var primaryBeneficiaries = beneficiaries.filter(function (b) {
    return b.beneficiaryAccountType === BeneficiaryAccountType.Primary;
  });
  var contingentBeneficiaries = beneficiaries.filter(function (b) {
    return b.beneficiaryAccountType === BeneficiaryAccountType.Contingent;
  });

  var totalPrimaryPercent = _.sumBy(primaryBeneficiaries, function (b) {
    return _.toNumber(b.percent);
  });

  var totalContingentPercent = _.sumBy(contingentBeneficiaries, function (b) {
    return _.toNumber(b.percent);
  });

  var errors = {}; // Block any contingent beneficiaries if no primary exists

  if (contingentBeneficiaries.length > 0) {
    if (primaryBeneficiaries.length === 0) {
      errors['beneficiaries[0].beneficiaryAccountType'] = 'At least one primary beneficiary is required before adding contingent beneficiaries.';
      errors['beneficiaries[0].percent'] = 'At least one primary beneficiary is required before adding contingent beneficiaries.';
      return errors;
    }

    if (totalPrimaryPercent !== 100) {
      primaryBeneficiaries.forEach(function (b, i) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries must total 100%.';
      });
      return errors;
    }

    if (totalContingentPercent !== 100) {
      contingentBeneficiaries.forEach(function (b, i) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Contingent beneficiaries must total 100%.';
      });
      return errors;
    }
  } // Validate primary percentages


  if (primaryBeneficiaries.length > 0) {
    if (totalPrimaryPercent > 100) {
      primaryBeneficiaries.forEach(function (b) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries cannot exceed 100%.';
      });
    } else if (totalPrimaryPercent < 100 && primaryBeneficiaries.length > 0) {
      primaryBeneficiaries.forEach(function (b) {
        var index = beneficiaries.indexOf(b);
        errors["beneficiaries[".concat(index, "].percent")] = 'Primary beneficiaries must total 100%.';
      });
    }
  }

  return errors;
};